module.exports = __webpack_public_path__ + "img/404.9ed13bbe.svg";